//-----------------
// calc adjs total
//-----------------
export default function calcAdjsTotal({ adjs, type }) {
  console.log('---------------------------------')
  console.log('IN calcAdjsTotal')
  console.log('type = ' + type)

  let return_adjs = adjs.filter((adj) => adj.name === type)
  return return_adjs.reduce((sum, adj) => sum + (adj.adj_value || 0), 0)
}
